<template>
  <div>
    <popup-add-product
      v-if="!isLoading"
      ref="popupAddMandatoryProduct"
      @productSelected="mandatoryProductSelected"
      :existingProducts="productsCombined"
      :totalVenueStock="stockProducts"
    />
    <popup-add-product
      v-if="!isLoading"
      ref="popupAddOptionalProduct"
      @productSelected="optionalProductSelected"
      :existingProducts="productsCombined"
      :totalVenueStock="stockProducts"
    />

    <vs-sidebar
      click-not-close
      position-right
      parent="body"
      default-index="1"
      max-items="100"
      color="primary"
      class="add-new-data-sidebar items-no-padding"
      spacer
      v-model="isActive"
    >
      <div class="mt-6 flex items-center justify-between px-6">
        <div class="flex items-center">
          <img width="40" :src="ProductIcon" class="mr-4" />
          <div>
            <h4>Assign stock to venue</h4>
          </div>
        </div>
        <feather-icon
          icon="XIcon"
          @click.stop="isActive = false"
          class="cursor-pointer"
        ></feather-icon>
      </div>
      <vs-divider class="mb-0"></vs-divider>

      <component
        :is="scrollbarTag"
        class="scroll-area--data-list-add-new"
        :settings="settings"
        :key="$vs.rtl"
      >
        <Loading v-if="isLoading" />
        <div v-else class="p-6">
          <p class="mb-3" style="font-weight: bold">Stock products</p>

          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Mandatory products</span>
            </div>
            <div>
              <vs-table
                :data="filteredMandatoryProducts"
                style="margin-left: -24px; margin-right: -24px"
                noDataText=""
              >
                <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
                <template slot="thead">
                  <!--                   <vs-th sort-key="namne"> Number </vs-th> -->
                  <vs-th sort-key="amount"> Name </vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <!--                <vs-td>
                      <div>{{ tr.name }}</div>
                      <div>
                        <small class="text-grey">{{
                          tr.stockProductId.id
                        }}</small>
                      </div>
                    </vs-td> -->

                    <vs-td>
                      <span class="text-muted"> {{ tr.name }}</span>
                    </vs-td>

                    <vs-td>
                      <feather-icon
                        @click="removeMandatoryProduct(tr.stockProductId.id)"
                        icon="TrashIcon"
                        class="cursor-pointer mr-2"
                        svgClasses="h-5 w-5 stroke-2"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
              <div class="flex justify-center mt-2">
                <vs-button
                  class="ml-2 py-2 px-3 rounded"
                  @click="$refs.popupAddMandatoryProduct.show()"
                >
                  Add product
                </vs-button>
              </div>
            </div>
          </div>

          <!-- Optional -->
          <div class="flex flex-col mb-3">
            <div class="mb-1 text-sm">
              <span>Optional products</span>
            </div>
            <div>
              <vs-table
                :data="filteredOptionalProducts"
                style="margin-left: -24px; margin-right: -24px"
                noDataText=""
              >
                <!--     <template slot="header">
                  <h3 class="ml-6 mb-1">Products</h3>
                </template> -->
                <template slot="thead">
                  <!--                   <vs-th sort-key="namne"> Number </vs-th> -->
                  <vs-th sort-key="amount"> Name </vs-th>
                  <vs-th></vs-th>
                </template>

                <template slot-scope="{ data }">
                  <vs-tr :data="tr" :key="tr.id" v-for="tr in data">
                    <!--                <vs-td>
                      <div>{{ tr.name }}</div>
                      <div>
                        <small class="text-grey">{{
                          tr.stockProductId.id
                        }}</small>
                      </div>
                    </vs-td> -->

                    <vs-td>
                      <span class="text-muted"> {{ tr.name }}</span>
                    </vs-td>

                    <vs-td>
                      <feather-icon
                        @click="removeOptionalProduct(tr.stockProductId.id)"
                        icon="TrashIcon"
                        class="cursor-pointer mr-2"
                        svgClasses="h-5 w-5 stroke-2"
                      />
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
              <!-- <p v-for="id in stocktake.stockProductIds" :key="id">{{ id }}</p> -->
              <div class="flex justify-center mt-2">
                <vs-button
                  class="ml-2 py-2 px-3 rounded"
                  @click="$refs.popupAddOptionalProduct.show()"
                >
                  Add product
                </vs-button>
              </div>
            </div>
          </div>
        </div>
      </component>

      <div class="flex flex-wrap items-center p-6" slot="footer">
        <vs-button class="mr-6" @click="assign" :disabled="!isFormValid">
          Assign
        </vs-button>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import ProductIcon from "@/assets/images/product-icon.png";
import { mapGetters } from "vuex";
import PopupAddProduct from "./PopupAddProduct.vue";

export default {
  components: {
    VuePerfectScrollbar,
    PopupAddProduct,
  },
  data() {
    return {
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      ProductIcon,

      isActive: false,
      isLoading: true,

      venueId: null,
      dto: null,
    };
  },
  computed: {
    ...mapGetters({
      stockProducts: "stockProducts/stockProducts",
      venueAllProducts: "pimVenues/venueAllProducts",
    }),
    productsCombined() {
      const venueAllProductsIds = this.venueAllProducts.map(
        (x) => x.stockProductId.id
      );
      return [
        ...this.dto.mandatoryStockProductIds, // Can't select if already in mandatory list
        ...this.dto.optionalStockProductIds, // Can't select if already in optional list
        ...venueAllProductsIds, // Can't select if already assigned to venue
      ];
    },
    filteredMandatoryProducts() {
      return this.stockProducts.filter((x) =>
        this.dto.mandatoryStockProductIds.includes(x.stockProductId.id)
      );
    },

    filteredOptionalProducts() {
      return this.stockProducts.filter((x) =>
        this.dto.optionalStockProductIds.includes(x.stockProductId.id)
      );
    },
    isFormValid() {
      return true;
    },
    scrollbarTag() {
      return this.$store.getters.scrollbarTag;
    },
  },
  methods: {
    removeOptionalProduct(id) {
      this.dto.optionalStockProductIds =
        this.dto.optionalStockProductIds.filter((x) => x !== id);
    },
    optionalProductSelected(productId) {
      console.log("Adding", productId);
      this.dto.optionalStockProductIds.push(productId);
    },
    removeMandatoryProduct(id) {
      this.dto.mandatoryStockProductIds =
        this.dto.mandatoryStockProductIds.filter((x) => x !== id);
    },
    mandatoryProductSelected(productId) {
      console.log("Adding", productId);
      this.dto.mandatoryStockProductIds.push(productId);
    },
    async showEmpty(venueId) {
      this.isActive = true;
      this.isLoading = true;

      this.venueId = venueId;
      this.dto = {
        mandatoryStockProductIds: [],
        optionalStockProductIds: [],
      };

      await this.loadExternalData();
      this.isLoading = false;
    },
    async loadExternalData() {
      await this.$store.dispatch("stockProducts/getStockProducts", {
        take: 100000,
        skip: 0,
      });

      await this.$store.dispatch("pimVenues/getVenue", this.venueId);
    },
    async assign() {
      console.log("Assigning dto", this.dto);

      try {
        const result = await this.$store.dispatch(
          "pimVenues/assignAssignedStockProducts",
          {
            venueId: this.venueId,
            dto: this.dto,
          }
        );

        this.$vs.notify({
          title: "Stock assigned",
          text: "The selected stock has been successfully assigned to the venue",
        });

        // wait 1 second
        await new Promise((resolve) => setTimeout(resolve, 1000));

        await this.$store.dispatch("pimVenues/getVenue", this.venueId);

        this.isActive = false;
        this.isLoading = false;
      } catch (err) {
        console.error(err);

        this.$vs.notify({
          color: "danger",
          title: "Error assigning stock",
          text: `Could not assign stock to venue`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
  // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
  height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

  &:not(.ps) {
    overflow-y: auto;
  }
}
</style>